import axios from 'axios';

export default axios.create({

  // baseURL:'http://localhost/tcms.testing.webapi/api',
  // For Development
  // baseURL: 'http://192.168.1.26:1999/api',
  // baseURL: 'http://localhost:1999/api',
  // inImageURL:'http://harel-12062001/tcms.teeparam.dev.in.winservice/FileUpload/Files',
  // // ukImageURL:'http://harel-12062001/tcms.teeparam.dev.uk.winservice/FileUpload/Files',
  // ukImageURL:'http://localhost/Prakash-2025',
  // slImageURL:'http://localhost/Prakash-2025',
  // commonImageURL:'http://localhost/Prakash-2026',

  // For Demo
  // baseURL:'http://targetdemo.asktek.net/tcms.teeparam.demo.webapi/api',
  // inImageURL:'http://targetdemo.asktek.net/tcms.teeparam.demo.in.winservice/FileUpload/Files',
  // ukImageURL:'http://targetdemo.asktek.net/tcms.teeparam.demo.uk.winservice/FileUpload/Files',
  // slImageURL:'http://targetdemo.asktek.net/tcms.teeparam.demo.sl.winservice/FileUpload/Files',
  // commonImageURL:'http://targetdemo.asktek.net/tcms.teeparam.web.images',

  // // For Testing
  // baseURL:'http://targettest.asktek.net/tcms.teeparam.testing.webapi/api',
  // inImageURL:'http://targettest.asktek.net/tcms.teeparam.testing.in.winservice/FileUpload/Files',
  // ukImageURL:'http://targettest.asktek.net/tcms.teeparam.testing.uk.winservice/FileUpload/Files',
  // slImageURL:'http://targettest.asktek.net/tcms.teeparam.testing.sl.winservice/FileUpload/Files',
  // commonImageURL:'http://targettest.asktek.net/tcms.teeparam.web.images',

  // For Dev
  // baseURL:'http://targetdev.asktek.net/dev.tcms.webapi/api',
  // inImageURL:'http://targetdev.asktek.net/tcms.teeparam.testing.in.winservice/FileUpload/Files',
  // ukImageURL:'http://targetdev.asktek.net/tcms.teeparam.testing.uk.winservice/FileUpload/Files',
  // slImageURL:'http://targetdev.asktek.net/tcms.teeparam.testing.sl.winservice/FileUpload/Files',
  // commonImageURL:'http://targetdev.asktek.net/tcms.teeparam.web.images',

  // For Live
  baseURL:'https://tracking.teeparam.com/bookingApi/api',
  inImageURL:'https://tracking.teeparam.com/TCMS_TEEPARAM_IND_PROD_SERVICE/FileUpload/Files',
  ukImageURL:'https://tracking.teeparam.com/TCMS_TEEPARAM_UK_PROD_SERVICE/FileUpload/Files',
  slImageURL:'https://tracking.teeparam.com/TCMS_TEEPARAM_SRILANKA_PROD_SERVICE/FileUpload/Files',
  commonImageURL:'https://tracking.teeparam.com/TCMS_Web_Images',
  headers: {
    authtoken: sessionStorage.getItem('authToken'),
    country: sessionStorage.getItem('country'),
  },

  // TRACKING URL

    // LIVE
 TRACKING_URL : 'https://tracking.teeparam.com/',

    // TESTING
//  TRACKING_URL : 'http://targettest.asktek.net/teeparam.tracking.tcms.webapp/',

  //  DEMO
//  TRACKING_URL : 'http://targetdemo.asktek.net/teeparam.tracking.tcms.demo.webapp/',

// LOCAL
//  TRACKING_URL : 'http://localhost:3001/',
});
